import React from 'react';
import { UserIcon, MailIcon, PhoneIcon, BriefcaseIcon, LinkedinIcon, BuildingIcon, TagsIcon, MapPinIcon, DollarSignIcon } from 'lucide-react';
export function OwnerFinderFields() {
  return <section className="py-24 bg-slate-50" data-id="element-5898">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5899">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-5900">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-5901">
            What you get for every local business{' '}
            <span className="text-blue-600" data-id="element-5902">owner</span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-5903">
            Our local business owner finder returns verified contact data and
            rich business context for every result.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-5904">
          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-5905">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-5906">
              <UserIcon className="w-6 h-6" data-id="element-5907" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-5908">
              Owner name
            </h3>
            <p className="text-slate-600" data-id="element-5909">
              Full name of the local business owner or primary decision-maker.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-5910">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-5911">
              <MailIcon className="w-6 h-6" data-id="element-5912" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-5913">
              Verified email
            </h3>
            <p className="text-slate-600" data-id="element-5914">
              Verified local business owner email address ready for outreach.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-5915">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-5916">
              <PhoneIcon className="w-6 h-6" data-id="element-5917" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-5918">
              Direct phone
            </h3>
            <p className="text-slate-600" data-id="element-5919">
              Direct dial and mobile numbers for business owner contacts.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-5920">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-5921">
              <BriefcaseIcon className="w-6 h-6" data-id="element-5922" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-5923">Job title</h3>
            <p className="text-slate-600" data-id="element-5924">
              Owner, Founder, GM, Managing Partner, and other titles.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-5925">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-5926">
              <LinkedinIcon className="w-6 h-6" data-id="element-5927" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-5928">
              LinkedIn profile
            </h3>
            <p className="text-slate-600" data-id="element-5929">
              Direct link to the business owner's LinkedIn profile.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-5930">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-5931">
              <BuildingIcon className="w-6 h-6" data-id="element-5932" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-5933">
              Business name
            </h3>
            <p className="text-slate-600" data-id="element-5934">Full legal business name and DBA.</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-5935">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-5936">
              <TagsIcon className="w-6 h-6" data-id="element-5937" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-5938">
              Business category
            </h3>
            <p className="text-slate-600" data-id="element-5939">
              Primary and secondary industry classifications.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-5940">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-5941">
              <MapPinIcon className="w-6 h-6" data-id="element-5942" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-5943">Location</h3>
            <p className="text-slate-600" data-id="element-5944">
              Full address, city, state, and ZIP code.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-5945">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-5946">
              <DollarSignIcon className="w-6 h-6" data-id="element-5947" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-5948">
              Revenue estimate
            </h3>
            <p className="text-slate-600" data-id="element-5949">
              Estimated annual revenue for qualifying leads.
            </p>
          </div>
        </div>
      </div>
    </section>;
}